import { useMutation } from '@tanstack/react-query'
import { authApi } from '../api/auth.api'

interface SendOTPParams {
    identifier: string
    channel: 'EMAIL' | 'SMS'
    purpose: 'SIGNUP' | 'LOGIN' | 'MFA' | 'PASSWORD_RESET'
}

export function useSendOTP() {
    return useMutation({
        mutationFn: ({ identifier, channel, purpose }: SendOTPParams) =>
            authApi.sendOTP(identifier, channel, purpose),
    })
}
